<template>
    <v-tooltip
        bottom
        :color="color"
        :disabled="disabled"
    >
        <template v-slot:activator="{ on }">
            <span v-on="on">
                <!-- Text to hover over -->
                <span v-if="simpleText !== ''" :alvqa="alvqa">
                    {{ $alvPlugin.isLangConst(simpleText) ? $t(simpleText) : simpleText}}
                </span>
                <span v-else :alvqa="alvqa"><slot name="content"></slot></span>
            </span>
        </template>
        <!-- Text in the tooltip -->
        <span v-if="simpleText !== ''">
           {{ $alvPlugin.isLangConst(simpleText) ? $t(simpleText) : simpleText}}
        </span>
        <slot v-else name="text"></slot>
    </v-tooltip>
</template>

<script>
export default {
    name: "BaseTooltip",
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: "tooltipBackground"
        },
        // if the content is the same as the text and nothing special content needed only use this prop and no slot
        simpleText: {
            type: String,
            default: ''
        },
        alvqa: {
            type: String,
            default: ''
        }
    }
}
</script>